import enTranslations from './translate.messages.en.json';
import etTranslations from './translate.messages.et.json';
import etCategories from './translate.item.categories.et.json';
import enCategories from './translate.item.categories.en.json';

const translations = {
  en: { ...enTranslations, ...enCategories },
  et: { ...etTranslations, ...etCategories },
};

export default translations;
